<template>
  <div>
    <div class="col-md-12">
      <h1 class="h3 mb-3 text-gray-800">
        Histórico de Relatórios RMA
      </h1>
    </div>

    <div class="col-md-12">
      <div class="card mb-0 shadow">
        <div class="card-body" v-if="!showRelatorio">
          <div class="row pb-3">
            <div class="col-auto">
              <a class="btn btn-default" @click="voltarRelatorios">
                <i class="mdi mdi-arrow-left" /> Voltar
              </a>
            </div>
          </div>
          <load v-if="loadRelatorios" mode="table" message="Carregando histórico de relatórios" />
          <RelatoriosList v-else :relatorios="relatorios" :anos="anosList" :meses="mesesList" :unidades="unidadesList"
            :tipos="tipos" :periodos="periodos" @open="abrirRelatorio" />
        </div>
        <div class="card-body" v-else>
          <div class="row pb-3 justify-content-between">
            <div class="col-auto">
              <a class="btn btn-default" @click="voltarHistorico">
                <i class="mdi mdi-arrow-left" /> Voltar ao histórico
              </a>
            </div>
            <div class="col-auto">
              <a class="btn btn-primary" @click="imprimirRelatorio" :title="$t('Imprimir')" v-b-tooltip.hover>
                <i class="mdi mdi-printer" />
              </a>
              <a class="btn btn-primary" @click="exportarRelatorio" :title="$t('Exportar')" v-b-tooltip.hover>
                <i class="fas fa-file-excel" />
              </a>
              <a v-if="relatorioAtual.tipo == 'cras'" class="btn btn-primary" @click="gerarXMLRelatorio" :title="$t('Gerar XML')" v-b-tooltip.hover>
                <i class="fas fa-file-code" />
              </a>
            </div>
          </div>
          <div id="boxPrint" class="col-12 px-0">
            <Header 
              :dados="relatorioAtual.conteudo" 
              :unidade="relatorioAtual.unidades" 
              :relatorio="relatorioAtual" 
              :mes="relatorioAtual.mes" 
              :ano="relatorioAtual.ano"
              :periodo="relatorioAtual.periodo" 
              :unidades="unidadeFormated" 
            />
            <Cras
              v-if="relatorioAtual.tipo == 'cras'"
              :unidade="relatorioAtual.unidades"
              :mes="relatorioAtual.mes"
              :ano="relatorioAtual.ano"
              :periodo="relatorioAtual.periodo"
              :dados="relatorioAtual.conteudo"
            />
            <Creas
              v-if="relatorioAtual.tipo == 'creas'"
              :mes="relatorioAtual.mes"
              :ano="relatorioAtual.ano"
              :periodo="relatorioAtual.periodo"
              :dados="relatorioAtual.conteudo"
            />
            <CentroPop
              v-if="relatorioAtual.tipo == 'centro pop'"
              :mes="relatorioAtual.mes"
              :ano="relatorioAtual.ano"
              :periodo="relatorioAtual.periodo"
              :dados="relatorioAtual.conteudo"
            />
            <Socioassistencial
              v-if="relatorioAtual.tipo == 'socioassistencial'"
              :mes="relatorioAtual.mes"
              :ano="relatorioAtual.ano"
              :periodo="relatorioAtual.periodo"
              :dados="relatorioAtual.conteudo"
            />
            <Gestor
              v-if="relatorioAtual.tipo == 'gestor'"
              :mes="relatorioAtual.mes"
              :ano="relatorioAtual.ano"
              :periodo="relatorioAtual.periodo"
              :dados="relatorioAtual.conteudo"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RelatoriosList from "./includes/ReadRelatorio";
import Cras from "./includes/CRAS";
import Creas from "./includes/CREAS";
import Gestor from "./includes/Gestor";
import CentroPop from "./includes/CentroPop";
import Socioassistencial from "./includes/Socioassistencial";
import Header from "./includes/Header";

export default {
  components: {
    RelatoriosList,
    Cras,
    Creas,
    Gestor,
    CentroPop,
    Socioassistencial,
    Header,
  },
  name: "HistoricoRelatorios",
  data() {
    return {
      relatorios: [],
      anosList: [],
      mesesList: [],
      unidadesList: [],
      periodos: [
        { id: "Mensal", value: "Mensal" },
        { id: "Anual", value: "Anual" },
      ],
      tipos: [
        { id: "cras", value: "CRAS" },
        { id: "creas", value: "CREAS" },
        { id: "centro pop", value: "Centro POP" },
        { id: "gestor", value: "Gestor" },
        {
          id: "socioassistencial",
          value: "Vigilância Socioassistencial",
        },
      ],
      loadRelatorios: true,
      showRelatorio: false,
      relatorioAtual: {},
      unidades: [],
      urlbase: window.urlbase,
    };
  },
  computed: {
    unidadeFormated() {
      if (!this.relatorioAtual.unidades || !Array.isArray(this.relatorioAtual.unidades)) {
        return "";
      }
      return this.unidades
        .filter(item => this.relatorioAtual.unidades.includes(item.id))
        .map(item => `<span class="badge bg-light text-dark border">${item.value}</span>`)
        .join('');
    }
  },
  mounted() {
    this.getUnidades();
    this.getRelatorios();
  },
  methods: {
    getUnidades() {
      axios.get(`api/dashboard/unidades/get/externas/rma`).then((response) => {
        this.unidades = response.data;
      });
    },
    getRelatorios() {
      this.loadRelatorios = true;
      axios
        .get(`api/dashboard/relatorios`)
        .then((response) => {
          this.relatorios = response.data.relatorios;
          this.mesesList = response.data.meses;
          this.anosList = response.data.anos;
          this.unidadesList = response.data.unidades;
        })
        .finally(() => {
          this.loadRelatorios = false;
        });
    },
    abrirRelatorio(relatorio) {
      this.relatorioAtual = relatorio;
      this.showRelatorio = true;
    },
    voltarHistorico() {
      this.showRelatorio = false;
      this.relatorioAtual = {};
    },
    voltarRelatorios() {
      this.$router.push(`/dashboard/relatorio/RMA`);
    },
    imprimirRelatorio() {
      const modal = document.getElementById("boxPrint");
      const cloned = modal.cloneNode(true);
      let section = document.getElementById("print");

      if (!section) {
        section = document.createElement("div");
        section.id = "print";
        document.body.appendChild(section);
      }

      section.innerHTML = "";
      section.appendChild(cloned);
      window.print();
    },
    exportarRelatorio() {
      swal.fire({
        title: "Aguarde! O Arquivo está sendo gerado.",
        text: "O tempo para finalizar pode demorar dependendo a quantidade De registros.",
        imageUrl: `${window.urlbase}img/load.gif`,
        showConfirmButton: false,
      });
      axios
        .post(`api/dashboard/relatorio/rma/export`, {
          tipo: this.relatorioAtual.tipo,
          unidade: this.relatorioAtual.unidades,
          periodo: this.relatorioAtual.periodo,
          mes: this.relatorioAtual.mes,
          ano: this.relatorioAtual.ano,
        })
        .then((response) => {
          swal.fire({
            title: "Arquivo Pronto para Download!",
            html: `<a href="${response.data.link}" target="_blank">Clique aqui para baixar</a>`,
            icon: "success",
            showConfirmButton: false,
          });
        })
        .catch((error) => {
          this.handleApiError(error, "Erro ao exportar o relatório.");
        })
    },
    gerarXMLRelatorio() {
      if (!Array.isArray(this.relatorioAtual.unidades) || this.relatorioAtual.unidades.length > 1) {
        swal.fire({
          title: "Erro!",
          text: "Para gerar o XML selecione apenas uma unidade.",
          icon: "error",
          confirmButtonText: "OK"
        });
        return;
      }

      if (this.relatorioAtual.periodo == 'Anual') {
        swal.fire({
          title: "Erro!",
          text: "Para gerar o XML selecione o período Mensal.",
          icon: "error",
          confirmButtonText: "OK"
        });
        return;
      }

      swal.fire({
        title: "Aguarde! O Arquivo está sendo gerado.",
        text: "O tempo para finalizar pode demorar dependendo a quantidade De registros.",
        imageUrl: `${window.urlbase}img/load.gif`,
        showConfirmButton: false,
      });
      axios
        .post(`api/dashboard/relatorio/rma/xml`, {
          tipo: this.relatorioAtual.tipo,
          unidade: this.relatorioAtual.unidades,
          periodo: this.relatorioAtual.periodo,
          mes: this.relatorioAtual.mes,
          ano: this.relatorioAtual.ano,
        })
        .then((response) => {
          this.downloadFile(response.data.link, 'XML');
          swal.fire({
            title: "URL Orientações para Upload do Arquivo XML no Portal MDS",
            html: `
            <ol style="text-align: left; display: flex; flex-direction: column; gap: 0.5rem; margin-top: 1rem;">
                <li><strong>Acesse o sistema do RMA</strong> no <a href="https://aplicacoes.mds.gov.br/sagi/atendimento/auth/index.php" target="_blank">Portal do MDS</a> com seu login e senha.</li>
                <li><strong>Selecione o mês e o ano</strong> de referência do registro.</li>
                <li>Clique em <strong>"Importar arquivo XML"</strong>.</li>
                <li><strong>Selecione o arquivo</strong> gerado pelo SUAS Fácil (ex.: <code>rma_cras_2025_03.xml</code>) e clique em <strong>"Enviar"</strong>.</li>
                <li><strong>Aguarde a validação</strong> automática do arquivo no Portal MDS.</li>
                <li>Após o envio bem-sucedido, o sistema exibirá uma mensagem de confirmação indicando que o arquivo foi recebido. <strong>Guarde esse comprovante para seus registros.</strong></li>
            </ol>
            `,
            icon: "success",
            showConfirmButton: true,
            confirmButtonText: "OK",
            width: '600px'
          })
        })
        .catch((error) => {
          this.handleApiError(error, "Erro ao gerar o arquivo XML.");
        })
    },
    downloadFile(url, fileType) {
      const link = document.createElement('a');
      link.href = url;
      link.download = '';
      
      document.body.appendChild(link);
      
      link.click();
      
      document.body.removeChild(link);
      
      swal.fire({
        title: "Arquivo Baixado com Sucesso!",
        text: `O arquivo ${fileType} foi baixado para seus downloads.`,
        icon: "success",
        timer: 3000,
        showConfirmButton: false,
      });
    },
    handleApiError(error, defaultMessage = "Ocorreu um erro inesperado.") {
      console.error("Erro completo:", error);
      
      let errorMessage = defaultMessage;
      
      if (error.response) {
        if (error.response.data) {
          if (error.response.data.message) {
            errorMessage = error.response.data.message;
          }
          else if (error.response.data.error) {
            errorMessage = error.response.data.error;
          }
          else if (error.response.data.errors) {
            const errors = Object.values(error.response.data.errors).flat();
            errorMessage = errors.join(' ');
          }
          else if (typeof error.response.data === 'string') {
            errorMessage = error.response.data;
          }
        }
      } 
      else if (error.request) {
        errorMessage = "Erro de conexão. Verifique sua internet e tente novamente.";
      } 
      else {
        errorMessage = error.message || defaultMessage;
      }
      
      swal.fire({
        title: "Erro!",
        text: errorMessage,
        icon: "error",
        confirmButtonText: "OK"
      });
      
      return errorMessage;
    },
  },
};
</script>

